import axios from 'axios';
import { useEventStore } from '../stores/event';

export async function activationLinkState(email, token) {
    try {
        const { data } = await axios.post('/api/sso/api/set-password/status', { email, token }, { timeout: 5000 });
        return data?.data?.state ?? null;
    } catch {
        return null;
    }
}

/**
 * Finish an invitation/approval activation once the account exists.
 *
 * SSO issues and validates the code. If it can't send one (e.g. the account is
 * already verified via the activation link), fall back to completion rather than
 * dead-ending the user on an un-fulfillable code screen.
 */
export async function finishActivation(email, changeFormStep, stepData = {}) {
    // Pass the Hub's subdomain/logo so SSO brands the verification email for this
    // Hub — omitting them makes it fall back to generic XtendLive branding.
    const { event } = useEventStore();
    try {
        await axios.post('/api/sso/api/email/resend-code', {
            email,
            subdomain: window.store?.subdomain,
            logo: event.value?.login_logo,
        });
        changeFormStep('verify-code', { ...stepData, email }, false);
    } catch (e) {
        console.error('verification code could not be sent; completing without it', e);
        changeFormStep('success-message', { ...stepData, email }, false);
    }
}
